import { render } from "./TestMicStart.vue?vue&type=template&id=5809daae"
import script from "./TestMicStart.vue?vue&type=script&lang=js"
export * from "./TestMicStart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__